import { engineComponent } from "neo-common";
import { HtmlContainerElement } from "../HTMLComponents/Elements/HtmlContainerElement";
import { ComponentTypes } from "../Components/ComponentTypes";

@engineComponent(ComponentTypes.HtmlElement)
export class HtmlCustomElement extends HtmlContainerElement {
    constructor() {
        super("");
    }

    /**
     * Get attributes from xml and set up supported properties.
     * @method create
     * @param node is Element from xml
     * @return void
     */
    create(node: Element): void {
        this.instance = document.createElement(node.nodeName);
        super.create(node);

        if (node.hasAttribute("colspan")) {
            const colspan = node.getAttribute("colspan");
            this.instance.setAttribute("colspan", colspan);
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/HtmlCustomElement.ts
 **/